import React, {useState} from "react";
import myCardStyle from "./MyCards.module.css"
import CardDescription from "./CardDescription";
import cabinetStyle from "./MentorCabinet.module.css";
import Style from "../Style.module.css";
import EditComponent from "./EditComponent";
import CloseComponent from "./CloseComponent";
import SaveComponent from "./SaveComponent";
import * as AssetsService from "../../api/AssetsService";
import {useTranslation} from "react-i18next";

function MyCard(props) {
    const [description, setDescription] = useState(false)
    const [edit, setEdit] = useState(false)
    const [newDescription, setNewDescription] = useState(props.card.card_text)
    const [newTitle, setNewTitle] = useState(props.card.title)
    const { t } = useTranslation('translation', { keyPrefix: 'myCard' });

    function openDescription() {
        if (description === true) {
            setDescription(false)
        } else {
            setDescription(true)
        }

    }

    function startEdit() {
        setEdit(true)
        setDescription(true)
    }

    function closeWithoutSave() {
        setEdit(false)
        setNewDescription(props.card.card_text)
        setNewTitle(props.card.title)
    }

    function saveNewDescription() {
        AssetsService.postCustomCardUpdate(
            props.card.id,
            newTitle,
            newDescription,
            () => {
                props.updateCards()
                setEdit(false)
            }
        )
    }

    return (
        <div>
            <div className={description ? cabinetStyle.commonTileCardsExtended : cabinetStyle.commonTileCards}>
                <div className={edit ? myCardStyle.myCardTopRowEditMode : myCardStyle.myCardTopRow}>
                    <div className={Style.h5Heading}
                         onClick={openDescription}>{props.cellNumber} - {props.card.title}</div>
                    {edit ?
                        <>
                            <CloseComponent actOnClick={closeWithoutSave}
                                            toolTipText={t('exitNoSave')}></CloseComponent>
                            <SaveComponent actOnClick={saveNewDescription}
                                           toolTipText={t('saveChanges')}/>
                        </>
                        :
                        <EditComponent openOnClick={startEdit} toolTipText={t('editCard')}/>
                    }
                </div>
                {description &&
                    <CardDescription edit={edit}
                                     setEdit={setEdit}
                                     setNewTitle={setNewTitle}
                                     newTitle={newTitle}
                                     setNewDescription={setNewDescription}
                                     newDescription={newDescription}
                    ></CardDescription>
                }
            </div>
        </div>

    )
}

export default MyCard;